module.exports = "<ng-select [(ngModel)]=\"organizationModel\" id=\"rso_select\" name=\"rso_select\" [items]=\"rsoList\" [multiple]=\"false\" [closeOnSelect]=\"true\"\r\n  bindLabel=\"name\" placeholder=\"Select organization...\" (change)=\"organizationChanged($event)\"></ng-select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/issc/rso-select/rso-select.component.html
// module id = ./src/app/shared/components/issc/rso-select/rso-select.component.html
// module chunks = main